module.exports = __webpack_public_path__ + "img/jyjh.e37efa92.jpg";